export function isNonNullObject(obj) {
    return obj !== null && typeof obj === 'object';
}
//# sourceMappingURL=objects.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/common/objects.js
// module id = 330
// module chunks = 4